import { Enum  } from "./Enum";

export const ShippingMethodEnum: Enum[] = [
  { id: 'regular', name: 'Regular' },
  { id: 'expedited', name: 'Expedited' },
  { id: 'own_account', name: 'Own Account' },
  { id: 'free', name: 'Free' },
];